import styled from 'styled-components';
import { Theme } from '@shared/theme';

const Selection = styled.div`
  display: flex;
  align-items: center;
  height: 46px;
  padding: 0 12px;
  color: rgba(255, 255, 255, 0.85);
  transition:
    color 0.2s,
    background 0.2s;

  & > [role='icon'] {
    margin-right: 6px;
  }

  &:hover {
    color: ${Theme.colors.primary};
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

const StyledActionBarWithoutStatic = styled.div<{ $flex?: boolean; $visible?: boolean }>`
  display: ${({ $flex, $visible = true }) => ($visible ? ($flex ? 'flex' : 'block') : 'none')};
  justify-content: space-between;
  align-items: center;
  flex: 1;

  & > *:not(:last-child) {
    margin-right: 8px;
  }
`;

const StyledActionBar = StyledActionBarWithoutStatic as typeof StyledActionBarWithoutStatic & {
  Selection: typeof Selection;
};

StyledActionBar.Selection = Selection;

export { StyledActionBar };
